import { Component, OnInit } from '@angular/core';
import {fadeInOutTranslate} from '../../shared/elements/animation';
import { Router } from'@angular/router';
import { AngularFireDatabase } from "angularfire2/database";
import swal from 'sweetalert2';;
import * as _ from "lodash";
import { NotificationToastService } from 'app/notification/notification-toast.service';
export const search_id = {
  id: ""
};
@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.css'],
  
  animations: [fadeInOutTranslate],
  providers:[AngularFireDatabase, NotificationToastService]
})
export class ContactsComponent implements OnInit {

  userrole: string = '';
  submitted: boolean;
  error: String = '';
  hasError: boolean;

  public imageToUpload = "assets/images/avatar-4.png";
  public sortOrder: string = "desc";
  public sortBy: string = "";
  public data: any;
  public rowsOnPage: number = 10;
  public filterQuery: string = "";

  constructor(private db:AngularFireDatabase, private router: Router) { }

  ngOnInit() {
    this.userrole = localStorage.getItem('courierapp_role');
    var x = this.db.list("/contacts");
    x.snapshotChanges().subscribe(item=>{
      this.data = [];
      item.forEach(element =>{
        var y = element.payload.toJSON();
          y["$key"] = element.key;
          this.data.push(y);
      });
    });
    this.checkSearchId();
  }
  checkSearchId()
  {
    if(search_id.id != "")
    {
      this.filterQuery = search_id.id;
    }
  }
  public refresh()
  {
    this.sortBy = "";
    this.filterQuery = "";
  }
  delete(customerId)
  {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(() => {
      this.db.object('/users/'+customerId).remove();
      swal({
        title:'Deleted!',
        text: 'Your file has been deleted.',
        type: 'success'
      })
    }).catch(swal.noop);
  }
  public view(id)
  {
    search_id.id = this.filterQuery;
    this.router.navigate(['/manage-contacts'], { queryParams : {key: id, from: 'contact'}  });
  }

}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/users/contacts/contacts.component.ts